<template>
  <div class="auth">
    <div class="login_panel">
      <div class="blue_border">
        <div class="title">Вход для партнеров</div>
        <div class="form_row">
          <div class="input_wrap">
            <input id="input_login" type="text"  v-model="auth_vars.login" class="input_gray">
            <label for="input_login" class="input_label">Логин</label>
          </div>
        </div>
        <div class="form_row">
          <div class="input_wrap">
            <input id="input_pass" type="password" v-model="auth_vars.pass" class="input_gray">
            <label for="input_pass" class="input_label">Пароль</label>
          </div>
        </div>
        <div v-if="!auth_vars.onload" class="form_row form_space">
          <div class="buttons">
            <input type="button" value="Войти" class="send" @click="tryLogin">
          </div>
        </div>
        <div v-else class="form_row">
          <loading></loading>
        </div>
        <div class="form_row">
          <div class="auth_text"><span class="psevdo_link" @click="show_modal_fb">Забыли пароль?</span></div>
          <div class="auth_text">
            Для изменения названия или логина - свяжитесь с вашим менеджером или отправьте сообщение через форму:<br>
            <span class="psevdo_link" @click="show_modal_fb">Обратной связи</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loading from "@/components/support/loading";
const axios = require('axios').default
import { useUserStore } from '@/stores/UserStore'
export default {
  name: 'auth',
  components: {
    loading,
  },
  setup() {
    const userStore = useUserStore()
    return {
      userStore,
    }
  },
  data: function (){
    return {
      auth_vars: {
        login: "",
        pass: "",
        onload: false,
      },
    }
  },
  methods: {
    tryLogin() {
      this.auth_vars.onload = true;
      this.$notifyInfo('Попытка авторизации');
      axios.post('/api/user_login', {
        login: this.auth_vars.login,
        password: this.auth_vars.pass,
        },{
        withCredentials: true,
        /**/
        headers: {
          //'Referrer-Policy': 'origin'
          //'crossDomain': true,
          //'Access-Control-Allow-Origin':  true,
          //'X-Requested-With': 'XMLHttpRequest'
        },
      }).then(res => {
        //console.log(res.cookie);
        if(typeof(res.data.success) != "undefined" && (res.data.success !== null) && (res.data.success == true)) {
          this.$notifySuccess('Успешная авторизация');
          this.$emit ('auth_success');
        }
        else
        {
          if(typeof(res.data.error) != "undefined" && typeof(res.data.message) != "undefined")
          {
            this.$notifyWarning(res.data.message);
          }
          console.log('Еrror auth');
        }
      }).catch(error => {
        console.log('Еrror', error);
      }).finally(() => ( this.auth_vars.onload = false));
    },
    show_modal_fb(){
      this.$emit('openModal');
    },
  }
}
</script>

<style scoped>
/* login page */
.login_panel {
  padding: 2%;
}
.login_panel .blue_border {
  margin-top: 20px;
  padding-bottom: 15px;
}
.login_panel {
  margin: 0 auto 0 auto;
  max-width: 480px;
}
.login_panel .form_row {
  margin: 0 0 10px 0;
}
.login_panel .input_wrap {
  width: 100%;
  margin: 0 0 0 0;
}
.login_panel .buttons {
  width: 100%;
  margin: 0 0 20px 0;
}
.login_panel .input_gray {
  width: 94%;
  padding-left: 2.5%;
  padding-right: 2.5%;
}
.login_panel .buttons input {
  width: 99%;
  margin: 0px;
}
.auth_text {
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 10px;
}
</style>

